import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { updateCommandoffer } from '../../../commandsActions';

const updateOfferOptions = [
  {
    value: 'STD_PRO_CO',
    name: 'Standard Livraison Entreprise'
  },
  {
    value: 'STD_PRO_SIGN_CO',
    name: 'Standard Signature Livraison Entreprise'
  },
  {
    value: 'STD_PRO',
    name: 'Standard'
  },
  {
    value: 'STD_PRO_SIGNATURE',
    name: 'Standard Signature'
  },
  {
    value: 'EXP_PRO_CO',
    name: 'Express Livraison Entreprise'
  },
  {
    value: 'EXP_PRO',
    name: 'Express'
  },
  // {
  //   value: 'STD_PRO_PICKUP_POINT',
  //   name: 'Standard Relais'
  // },
  // {
  //   value: 'EXP_PRO_PICKUP_POINT',
  //   name: 'Express Relais'
  // },
  {
    value: 'STD_PRO_PALLET',
    name: 'Standard Palette'
  },
  {
    value: 'COURIER_A_LA_CARTE',
    name: 'Coursier à la carte',
    disabled: true
  }
];

/**
 * Affiche les informations de base sur la commande
 * ( dimension du colis, montant de l'assurance, coût de l'assurance... )
 */
const UpdateDeliveryOffer = ({ command, dispatchUpdateCommandOffer }) => {
  const handleChange = event => {
    dispatchUpdateCommandOffer({
      commandId: command.id,
      offerCode: event.target.value
    });
  };

  const foundOffer = updateOfferOptions.findIndex(
    option => option.value === command.offer.code
  );

  if (foundOffer === -1) {
    return (
      <Typography variant="body2" gutterBottom>
        {`Offre de livraison : ${command.offer.name}`}
      </Typography>
    );
  }
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="body2" gutterBottom>
        Offre de livraison :
      </Typography>
      <Box ml={2}>
        <FormControl>
          <Select
            value={command.offer.code}
            onChange={handleChange}
            disabled={!command.canAddressBeChanged}
          >
            {updateOfferOptions.map(option => (
              <MenuItem
                value={option.value}
                key={option.value}
                disabled={option.disabled}
              >
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchUpdateCommandOffer: params => dispatch(updateCommandoffer(params))
});

UpdateDeliveryOffer.propTypes = {
  command: PropTypes.object.isRequired,
  dispatchUpdateCommandOffer: PropTypes.func.isRequired
};

export default connect(
  null,
  mapDispatchToProps
)(UpdateDeliveryOffer);
